import React, { useContext } from 'react';
import { PageShellLayout, PageShell } from 'src/styles/pageLayoutStyles';
import styled from 'styled-components';
import { SustainabilityLandingPageConstants } from 'src/constants/ProjectConstants';
import { KeyOfferings, Section } from 'src/components/LandingPage';
import { TranslationContext } from 'src/state/providers/TranslationProvider';
import {
  ANONYMOUS_CREATE_CASE_PAGE_ROUTE,
  CREATE_CASE_PAGE_ROUTE,
  LIST_CASE_PAGE_ROUTE,
  SUSTAINABILITY_URL_PATTERN,
} from 'src/constants/UrlConstants';
import { AuthUrlGeneration } from 'src/routes/helpers/AuthenticatedRoute';
import { AuthContext } from 'src/state/providers/AuthProvider';
import { useNavigate } from 'react-router';
import { useLocalizationContext } from '@amzn/react-arb-tools';
import { TrustSectionBody } from './TrustSectionBody';

const TrustContainer = styled.div`
  padding: 2rem 1.5rem 2.5rem 1.5rem; /* top right bottom left  */
  background-color: ${({ theme }) => theme.colors.Snow};
`;

const HowToReportSection = styled.div`
  background-color: ${({ theme }) => theme.colors.Zircon};
  padding: 1rem 1.5rem 1rem 1.5rem; /* top right bottom left  */
`;

const CreateCaseFormContainer = styled.div`
  padding: 0rem 0rem 0rem 0rem; /* top right bottom left  */
  background-color: ${({ theme }) => theme.colors.White};
  border: solid 1px;
  border-color: ${({ theme }) => theme.colors.Zircon};
`;

const LandingPage = () => {
  const navigate = useNavigate();
  const { socialResponsibilityLandingPageBundle, commonBundle } =
    useContext(TranslationContext);
  const authContext = useContext(AuthContext);
  const { localizationContext } = useLocalizationContext();
  const anonymousUser: boolean = !authContext.customerId ? true : false;

  return (
    <PageShellLayout>
      <PageShell>
        <TrustContainer data-testid="trust-container">
          <Section
            header={socialResponsibilityLandingPageBundle.getMessage(
              SustainabilityLandingPageConstants.TRUST_SECTION_HEADER,
            )}
          >
            <TrustSectionBody />
          </Section>
        </TrustContainer>
        <HowToReportSection data-testid="how-to-report-section">
          <KeyOfferings
            header={socialResponsibilityLandingPageBundle.getMessage(
              SustainabilityLandingPageConstants.HOW_TO_REPORT_HEADING,
            )}
            items={[
              {
                header: socialResponsibilityLandingPageBundle.getMessage(
                  SustainabilityLandingPageConstants.REPORTING_CARD_ANONYMOUSLY_HEADER,
                ),
                iconName: 'share',
                description: socialResponsibilityLandingPageBundle.getMessage(
                  SustainabilityLandingPageConstants.REPORTING_CARD_ANONYMOUSLY_DESCRIPTION,
                ),
                primaryButtonLabel:
                  socialResponsibilityLandingPageBundle.getMessage(
                    SustainabilityLandingPageConstants.REPORTING_CARD_ANONYMOUSLY_ACTION_BUTTON_LABEL,
                  ),
                primaryButtonAction: () => {
                  const uri = `${SUSTAINABILITY_URL_PATTERN}/#${ANONYMOUS_CREATE_CASE_PAGE_ROUTE}`;
                  window.location.assign(uri);
                },
              },
              {
                hidden: !anonymousUser,
                header: socialResponsibilityLandingPageBundle.getMessage(
                  SustainabilityLandingPageConstants.REPORTING_CARD_ANONYMOUS_LOGIN_HEADER,
                ),
                iconName: 'list',
                description: socialResponsibilityLandingPageBundle.getMessage(
                  SustainabilityLandingPageConstants.REPORTING_CARD_ANONYMOUS_LOGIN_DESCRIPTION,
                ),
                primaryButtonLabel:
                  socialResponsibilityLandingPageBundle.getMessage(
                    SustainabilityLandingPageConstants.REPORTING_CARD_ANONYMOUS_LOGIN_ACTION_BUTTON_LABEL_SIGN_IN,
                  ),
                primaryButtonAction: () => {
                  const uri = `${SUSTAINABILITY_URL_PATTERN}/#${CREATE_CASE_PAGE_ROUTE}`;
                  const encodedUrl = encodeURIComponent(uri);
                  const returnUrl = `${window.location.origin}/${encodedUrl}`;
                  const generatedAuthUrl = AuthUrlGeneration.generateAuthUrl(
                    localizationContext.getLocale(),
                    returnUrl,
                  );
                  window.location.assign(generatedAuthUrl);
                },
              },
              {
                hidden: anonymousUser,
                header: socialResponsibilityLandingPageBundle.getMessage(
                  SustainabilityLandingPageConstants.REPORTING_CARD_LOGGED_IN_VIEW_LOGIN_HEADER,
                ),
                iconName: 'list',
                description: socialResponsibilityLandingPageBundle.getMessage(
                  SustainabilityLandingPageConstants.REPORTING_CARD_LOGGED_IN_VIEW_LOGIN_DESCRIPTION,
                ),
                primaryButtonLabel:
                  socialResponsibilityLandingPageBundle.getMessage(
                    SustainabilityLandingPageConstants.REPORTING_CARD_LOGGED_IN_VIEW_LOGIN_PRIMARY_ACTION_REPORT,
                  ),
                primaryButtonAction: () => {
                  navigate(CREATE_CASE_PAGE_ROUTE);
                },
                secondaryButtonlabel:
                  socialResponsibilityLandingPageBundle.getMessage(
                    SustainabilityLandingPageConstants.REPORTING_CARD_LOGGED_IN_VIEW_LOGIN_SECONDARY_ACTION_TRACK_ISSUES,
                  ),
                secondaryButtonAction: () => {
                  navigate(LIST_CASE_PAGE_ROUTE);
                },
              },
            ]}
          />
        </HowToReportSection>
      </PageShell>
    </PageShellLayout>
  );
};

export { LandingPage };
